import { render } from "./editorJs.vue?vue&type=template&id=044370c6&scoped=true"
import script from "./editorJs.vue?vue&type=script&lang=js"
export * from "./editorJs.vue?vue&type=script&lang=js"

import "./editorJs.vue?vue&type=style&index=0&id=044370c6&scoped=true&lang=scss"

import exportComponent from "/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-044370c6"]])

export default __exports__